export enum EditFormKeys {
    Name = 'name',
    Description = 'description',
    ProductInfoUrl = 'productInfoUrl',
    Code = 'code',
    Active = 'active',
    Sort = 'sort',
    Price = 'price',
    WithoutPrice = 'withoutPrice',
    Place = 'place',
    Type = 'type',
    Date = 'date',
    Image = 'image',
    Files = 'files',
    Catalogs = 'catalogs',
    TextOrderSuccess = 'textOrderSuccess',
    TextOrderFail = 'textOrderFail',
    EmailDomainRestricted = 'emailDomainRestricted',

    /* CRM */
    CRMInterestCode = 'crmInterestCode',
    CRMProductExternalId = 'crmProductExternalId',
    CRMNeedOpportunity = 'crmNeedOpportunity',
}
